
import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import AngleRight from "react-icons/lib/fa/angle-right"
import {get} from "lodash"

import {minWidthMedia} from "@irati/ui/src/global/media"
import id from "@irati/utils/id"
import {injectIntl} from "@irati/utils/lang"
import {RouterLink} from "@irati/ui/src/Link"
import {connect} from "@irati/store"
import padding from "@irati/ui/src/global/padding"
import {greys} from "@irati/ui/src/global/colors"
import {twoPxShadow, twoPxShadowBigBlur} from "@irati/ui/src/global/elevation"
import {Label2, Label3} from "@irati/ui/src/Labels"
import {formatDriverName} from "@irati/insights/utils/string"

import {H3Css} from "../../ui/Headings"
import Bar from "./Bar"
import helper from "../../helpers/DriverIcon"
import {Image} from "../../ui/Image"

const ScoreRouterLink = styled(RouterLink)`
    display: flex;
    margin-bottom: ${padding.tiny};
    flex-wrap: wrap;
    padding: 15px;
    background-color: ${greys.white};
    ${twoPxShadow}
    border-radius: 3px;
    :hover {
      text-decoration: none;
      ${twoPxShadowBigBlur}
    }
`


const Wrapper = styled.div`
  display: flex;
  position: relative;
  justify-content: space-between;
  flex-grow: 1;
  align-items: center;
  margin-bottom: 10px;

  ${minWidthMedia.tablet`
     margin-bottom: 0;
  `}
`

const DriverIconAndNameContainer = styled.div`
  display: flex;
  align-items: center;

  ${minWidthMedia.tablet`
    position: relative;
   `}
`

const ScoreContainer = styled(Label3)`
  ${H3Css}
  text-align: right;
  min-width: 70px;

  ${minWidthMedia.tablet`
    margin-left: 25px;
`}
`

const DriverNameContainer = styled(Label2)`
  padding-left: 10px;
  vertical-align: middle;
  text-transform: capitalize;
  max-width: 120px;

  ${minWidthMedia.tablet`
    text-transform: capitalize;
    min-width: 200px;
  `}
`

const Arrow = styled(AngleRight)`
  align-self: center;
  margin-left: 15px;
`


const DriverScoreRouterLink = ({driver, to, isPhone, formatMessage, ...props}) => {
  const idNamespace = id("driverScoreLink", props)
  const {contentId: driverContentId, score: driverAverageScore} = driver

  return (
    <ScoreRouterLink to={to} id={idNamespace}>
      <Wrapper>
        <DriverIconAndNameContainer>
          <Image src={helper.getDriverIcon(driverContentId)} alt="" size={45} />
          <DriverNameContainer>{formatDriverName(formatMessage, driver)}</DriverNameContainer>
        </DriverIconAndNameContainer>
        {!isPhone && <Bar score={driverAverageScore} />}
        <ScoreContainer>{driverAverageScore}</ScoreContainer>
      </Wrapper>
      <Arrow size={16} />
      {isPhone && <Bar score={driverAverageScore} forMobile />}
    </ScoreRouterLink>
  )
}


DriverScoreRouterLink.propTypes = {
  driver: PropTypes.object.isRequired,
  to: PropTypes.string.isRequired,
  formatMessage: PropTypes.func.isRequired,
  isPhone: PropTypes.bool
}
DriverScoreRouterLink.defaultProps = {
  isPhone: false
}

const mapStateToProps = ({mq}) => ({isPhone: get(mq, "lessThan.medium", false)})

export default injectIntl(connect(mapStateToProps)(DriverScoreRouterLink))
